<div class="hot-tours">
  <div class="hot-tours__title title">
    <span class="title__header">{{ 'HotToursBlock.Header' | translate }}</span>
    <span class="title__description">{{ 'HotToursBlock.Description' | translate }}</span>
  </div>
  <app-hot-tours-list [tours]="hotTours | async" class="hot-tours__list"></app-hot-tours-list>
</div>
